import { useI18n } from "@/plugins/i18n";
import { computed } from "vue";
import img from "@/assets/images/app/integrations/sellar.png";
import { integrationsMenu } from "@/app/ui/navigation/integrationsMenu";
import type { MultiIntegrationMeta } from "./types";
import type Guid from "@/app/types/common/guid";
import type { LocalDate } from "@js-joda/core";
import {
  sellarLinkService,
  SellarOrderFilter,
} from "@/app/services/generated/sellarlinkService";
import { fillFilterDates } from "@/store/modules/integrationErrorStore";

export function useSellarIntegration() {
  const { $m } = useI18n();

  const sellarMeta = computed((): MultiIntegrationMeta => {
    return {
      name: $m.sellar_title,
      description: $m.sellar_card_content,
      integrationRoute: (id: Guid) => integrationsMenu.sellar.viewLocation(id),
      miniImg: img,
      img,
      url: $m.sellar_url,
      guideUrl: $m.sellar_guide,
      createIntegrationRoute: integrationsMenu.sellar.createLocation(),
    };
  });

  return {
    sellarMeta,
  };
}

export async function getSellarOrders(
  fromDate?: LocalDate,
  toDate?: LocalDate | null,
  accountNames?: string[]
) {
  const filter = fillFilterDates(new SellarOrderFilter(), fromDate, toDate);
  if (accountNames) {
    filter.sellarAccountNames = accountNames;
  }

  return (await sellarLinkService.getSellarOrdersByFilter(filter)).sellarOrders;
}
